export default interface DASHBOARDS_PANELS
{
	ID                            : string  ; // uniqueidentifier
	PANEL_ORDER                   : number  ; // int
	ROW_INDEX                     : number  ; // int
	COLUMN_WIDTH                  : number  ; // int
	DASHBOARD_ID                  : string  ; // uniqueidentifier
	DASHBOARD_APP_ID              : string  ; // uniqueidentifier
	NAME                          : string  ; // nvarchar
	CATEGORY                      : string  ; // nvarchar
	MODULE_NAME                   : string  ; // nvarchar
	TITLE                         : string  ; // nvarchar
	SETTINGS_EDITVIEW             : string  ; // nvarchar
	IS_ADMIN                      : boolean ; // bit
	APP_ENABLED                   : boolean ; // bit
	SCRIPT_URL                    : string  ; // nvarchar
	DEFAULT_SETTINGS              : string  ; // nvarchar
	PANEL_TYPE?                   : string  ; // nvarchar
}

